import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";

function clusterIcon(cluster) {
  const n = cluster.getChildCount();
  const size = n < 10 ? 40 : n < 25 ? 48 : 56;
  return L.divIcon({
    html: `<div data-testid="map-cluster-${cluster.getAllChildMarkers().map(m => m.options.placeId).sort()[0]}" class="vv-cluster" style="width:${size}px;height:${size}px;"><span>${n}</span></div>`,
    className: "vv-cluster-wrap",
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

export default function ClusterLayer({ places, iconFor, onSelect }) {
  const map = useMap();
  const groupRef = useRef(null);

  useEffect(() => {
    const group = L.markerClusterGroup({
      showCoverageOnHover: false,
      spiderfyOnMaxZoom: true,
      maxClusterRadius: 60,
      iconCreateFunction: clusterIcon,
    });
    map.addLayer(group);
    groupRef.current = group;
    return () => { map.removeLayer(group); groupRef.current = null; };
  }, [map]);

  useEffect(() => {
    const group = groupRef.current;
    if (!group) return;
    group.clearLayers();
    const markers = places.map((p) => {
      const m = L.marker([p.lat, p.lng], { icon: iconFor(p), title: p.name, placeId: p.id });
      m.on("add", () => m.getElement()?.setAttribute("data-testid", `map-pin-${p.id}`));
      m.on("click", () => onSelect(p));
      return m;
    });
    group.addLayers(markers);
  }, [places, iconFor, onSelect]);

  return null;
}
